"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKcContext = void 0;
var getKcContext_1 = require("./getKcContext");
Object.defineProperty(exports, "getKcContext", { enumerable: true, get: function () { return getKcContext_1.getKcContext; } });
//# sourceMappingURL=index.js.map